import withPhones from './withPhones';
import withRoles from './withRoles';
import withWorkstationPhoneId from './withWorkstationPhoneId';

export default Component => withRoles(withWorkstationPhoneId(withPhones(Component)));
